import Head from "next/head";
import React from "react";
import { IProjectBySlugQuery } from "~/src/components/project/graphql/__generated__/ProjectBySlugQuery.generated";

interface IProjectHeadProps {
  project: NonNullable<IProjectBySlugQuery["projectBySlug"]>;
}

export default function ProjectHead({ project }: IProjectHeadProps) {
  if (!project) {
    return null;
  }

  if (project.__typename === "GovernmentProject") {
    const { title, subtitle, description, tags, government, createdAt, updatedAt } = project;

    return (
      <Head>
        <title>{subtitle || title}</title>

        <meta name="description" content={description || ""} />
        <meta name="twitter:card" content="summary" />

        <meta name="twitter:site" content="@Govlaunch" />
        <meta name="twitter:image" content={government.logo || ""} />
        <meta name="twitter:title" content={title || ""} />
        <meta name="twitter:description" content={description || ""} />

        <meta name="article:publisher" content={`https://govlaunch.com/governments/${government.slug}`} />
        {tags && tags.length > 0 && <meta name="article:section" content={tags[0].name || ""} />}
        <meta name="article:published_time" content={createdAt || undefined} />
        {updatedAt && <meta name="article:modified_time" content={updatedAt} />}

        <meta property="og:title" content={title || ""} />
        <meta property="og:description" content={description || ""} />
        <meta property="og:image" content={government.logo || ""} />
      </Head>
    );
  }

  if (project.__typename === "VendorProject") {
    const { title, subtitle, description, tags, vendor, createdAt, updatedAt } = project;

    return (
      <Head>
        <title>{subtitle || title}</title>

        <meta name="description" content={description || ""} />
        <meta name="twitter:card" content="summary" />

        <meta name="twitter:site" content="@Govlaunch" />
        <meta name="twitter:image" content={vendor.logo || ""} />
        <meta name="twitter:title" content={title || ""} />
        <meta name="twitter:description" content={description || ""} />

        <meta name="article:publisher" content={`https://govlaunch.com/vendors/${vendor.slug}`} />
        {tags && tags.length > 0 && <meta name="article:section" content={tags[0].name || ""} />}
        <meta name="article:published_time" content={createdAt || undefined} />
        {updatedAt && <meta name="article:modified_time" content={updatedAt} />}

        <meta property="og:title" content={title || ""} />
        <meta property="og:description" content={description || ""} />
        <meta property="og:image" content={vendor.logo || ""} />
      </Head>
    );
  }

  if (project.__typename === "GroupProject") {
    const { subtitle, title, description, tags, group } = project;

    return (
      <Head>
        <title>{subtitle || title}</title>

        <meta name="description" content={description || ""} />
        <meta name="twitter:card" content="summary" />

        <meta name="twitter:site" content="@Govlaunch" />
        <meta name="twitter:image" content={group.logo || ""} />
        <meta name="twitter:title" content={title || ""} />
        <meta name="twitter:description" content={description || ""} />

        {tags && tags.length > 0 && <meta name="article:section" content={tags[0].name || ""} />}

        <meta property="og:title" content={title || ""} />
        <meta property="og:description" content={description || ""} />
        <meta property="og:image" content={group.logo || ""} />
      </Head>
    );
  }

  return null;
}
